import { CheckIcon } from "@radix-ui/react-icons";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import getLogsFromAlcoholData from "src/lib/getLogsFromAlcoholData";
import { useApiRequest } from "src/lib/hooks/useApiRequest";
import SaveSessionDrawer from "../SaveSessionDrawer";
import { Button } from "../ui/button";

export default function FinishPartyButton({ mutate }: { mutate?: () => void }) {
  const [loading, setLoading] = useState(false);
  const alcoholData = useSelector((state: any) => state.alcohol);
  const userLogs = getLogsFromAlcoholData(alcoholData);

  const apiRequest = useApiRequest();

  const finishParty = async () => {
    if (userLogs.length === 0) {
      setLoading(true);
      const response = await apiRequest.post("/parties/finish", {});
      if (!response) {
        toast.error("Nepodařilo se tuhle kalbu zabalit");
        return;
      }
      toast.success("Tuhle kalbu jsi zabalil/a");
      if (mutate) mutate();
      setLoading(false);
    }
  };

  const Wrapper = useCallback(
    ({ children }) => {
      if (userLogs.length === 0) {
        return children;
      } else {
        return (
          <SaveSessionDrawer mutate={mutate}>{children}</SaveSessionDrawer>
        );
      }
    },
    [userLogs.length, mutate]
  );

  return (
    <Wrapper>
      <Button
        variant="outline"
        className="gap-2"
        onClick={finishParty}
        disabled={loading}
      >
        <CheckIcon />
        Zabalit to
      </Button>
    </Wrapper>
  );
}
